import { ReactNode } from "react";
import { atom, useAtom } from "jotai";
import { FilterState, GlobalState } from "@/types";

const defaultState: GlobalState = {
  isPot: false,
  filters: {
    types: [],
    subtypes: [],
  },
  showSideBar: true,
  showAuthBar: true,
  containerize: true,
  sidebarContent: null,
  backgroundClass: "bg-brand-background",
};

const globalAtom = atom(defaultState);

const useGlobals = () => {
  const [globalState, setGlobalState] = useAtom(globalAtom);

  const updateFilters = (filters: FilterState) => {
    setGlobalState((p) => ({ ...p, filters }));
  };

  return {
    ...globalState,
    setGlobalState: (
      key: keyof Omit<GlobalState, "filters">,
      value: string | ReactNode | null,
    ) => {
      setGlobalState((p) => ({ ...p, [key]: value }));
    },
    updateFilters,
  };
};

export default useGlobals;
